import Vue from 'vue'

// integration popup components load
import primaveraIntegrate from '@/components/integrations/integratePopup/primaveraIntegrate'
import gygIntegrate from '@/components/integrations/integratePopup/gygIntegrate'
import stripeIntegrate from '@/components/integrations/integratePopup/stripeIntegrate'
import hugLocalsIntegrate from '@/components/integrations/integratePopup/hugLocalsIntegrate'
import octoIntegrate from '@/components/integrations/integratePopup/octoIntegrate'
import ViatorIntegrate from '@/components/integrations/integratePopup/viatorIntegrate'

const state = {
    integrationTypes: [
        {
            id: 3,
            label: 'Invoicing',
            description: 'Add automatic or manual invoicing to your operation',
        },
        {
            id: 1,
            label: 'Payment Gateway',
            description: 'Add more ways of payment to your bookings',
        },
        {
            id: 2,
            label: 'OTA',
            description: 'Sell your products directly on other platforms',
        },
    ],
    integrationStates: [
        {
            id: -1,
            label: 'Coming Soon',
            backgroundColor: 'color-4',
            textColor: 'darkest',
        },
        {
            id: 0,
            label: 'Not Connected',
            backgroundColor: 'medium',
            textColor: 'darkest',
        },
        {
            id: 1,
            label: 'Connected',
            backgroundColor: 'color-3',
            textColor: 'lightest',
        },
        {
            id: 2,
            label: 'Connection Requested',
            backgroundColor: 'color-4',
            textColor: 'darker',
        },
        {
            id: 3,
            label: 'Disconnect Pending',
            backgroundColor: 'color-4',
            textColor: 'darker',
        },
        {
            id: 4,
            label: 'Not Configured',
            backgroundColor: 'color-4',
            textColor: 'darker',
        }
    ],
    allIntegrations: [
        {
            id: 301,
            type: 3,
            label: 'Primavera',
            comingSoon: false,
            color: {
                main: '#0776BC',
                accent: '#0776BC',
            },
            logo: {
                color: require('@/assets/images/integrations/primavera/logoColor.svg'),
                white: require('@/assets/images/integrations/primavera/logoWhite.svg'),
            },
            descriptionSmall: 'Our integration with Primavera enables automated invoicing and effortlessly sends invoices directly to customers.',
            integratePopup: primaveraIntegrate,
            settings: (commit, dispatch, getters) => {
                dispatch('openModalDirect', {
                    name: 'primaveraIntegrate',
                    component: primaveraIntegrate
                })
            },
            integrationSpecifics: {
                validations:{
                    vat: 20,
                    name: 50,
                    address: 50,
                    phone: 20,
                    email: 50,
                    code: 12,
                    location: 50,
                    postalCode: 15,
                    country: 2,
                }
            }
        },
        {
            id: 101,
            type: 1,
            label: 'Stripe',
            comingSoon: false,
            color: {
                main: '#6772e5',
                accent: '#6772e5',
            },
            logo: {
                color: require('@/assets/images/integrations/stripe/logo.svg'),
                white: require('@/assets/images/integrations/stripe/logoWhite.svg'),
            },
            descriptionSmall: 'Accept credit cards from all over the world',
            integratePopup: stripeIntegrate,
        },
        {
            id: 205,
            type: 2,
            label: 'Other integration',
            showView: true,
            comingSoon: false,
            showStatus: false,
            color: {
                main: '#8ca0b3',
                accent: '#a64660',
            },
            logo: {
                color: require('@/assets/images/integrations/octo/octo.png'),
                white: require('@/assets/images/integrations/octo/octo.png'),
            },
            descriptionSmall: 'This integration is available exclusively for OTAs that follow the OCTO standard, enabling connectivity with over 120 OTAs',
            descriptionModal: 'The OCTO standard is a set of norms and protocols designed to simplify integration between different OTAs (Online Travel Agencies)',
            integratePopup: octoIntegrate,
            settings: (commit, dispatch, getters) => {
                console.log('integration settings')
                dispatch('openModalDirect', {
                    name: 'octoIntegrate',
                    component: octoIntegrate
                })
            }
        },
        {
            id: 202,
            type: 2,
            label: 'GetYourGuide',
            comingSoon: false,
            color: {
                main: '#FF5533',
                accent: '#FF5533',
            },
            logo: {
                color: require('@/assets/images/integrations/getYourGuide/logo.svg'),
                white: require('@/assets/images/integrations/getYourGuide/logo_white.svg'),
            },
            descriptionSmall: 'Manage all bookings from your GetYourGuide account. Make sure your account with GetYourGuide is active and connect with Pluralo.',
            integratePopup: gygIntegrate,
            settings: (commit, dispatch, getters) => {
                dispatch('setSelectedPerson', getters.getAgentByChannelType(202))
                dispatch('openModal','AgentView')
            }
        },
        {
            id: 203,
            type: 2,
            label: 'Viator',
            color: {
                main: '#186B6D',
                accent: '#AF143E',
            },
            logo: {
                color: require('@/assets/images/integrations/viator/logo.svg'),
                white: require('@/assets/images/integrations/viator/logo_white.svg'),
            },
            descriptionSmall: 'Viator makes it simple for travelers to find exactly what they want to do. With direct access to more than 200,000 bookable activities, travelers can easily discover and book incredible experiences.',
            integratePopup: ViatorIntegrate,
            settings: (commit, dispatch, getters) => {
                dispatch('setSelectedPerson', getters.getAgentByChannelType(203))
                dispatch('openModal','AgentView')
            }
        }
    ],
    isLoadingSupplierIntegrations: false,
    supplierIntegrations: [],
    isTestingPrimaveraConnection: false,
    isResquestingSeries: false,
    primaveraSeries: [],
    isResquestingPaymentConditions: false,
    paymentConditions: [],
    isResquestingPaymentTypes: false,
    paymentTypes: [],
    isResquestingErpPaymentTypes: false,
    erpPaymentTypes: [],
    isPrimaveraSettingsSaving: false,
    selectedIntegration: null,
    isOctoConnecting: false,
    finalIntegrations: [],
    groupedIntegrations: [],
    isViatorConnecting: false,
    isEnableOrDisableViatorConnecting: false,
};

const getters = {
    getAllIntegrations: state => {
        return state.finalIntegrations;
    },
    getSingleIntegration: state => (integrationId) => {
        return state.finalIntegrations.find(integration => integration.id == integrationId);
    },
    getIntegrationStatus: state => (statusId) => {
        return state.integrationStates.find(state => state.id == statusId);
    },
    getAllIntegrationsGrouped: (state) => {
        return state.groupedIntegrations;
    },
    getSupplierIntegrations: state => state.supplierIntegrations,
    getIsLoadingSupplierIntegrations: state => state.isLoadingSupplierIntegrations,
    getInvoiceSystemIntegration: (state) => {
        const finalIntegrations = state.finalIntegrations;

        if (!finalIntegrations || finalIntegrations.length == 0) {
            return false;
        }

        const foundInvoiceSystemIntegration = finalIntegrations.find(integration => integration.integrationType == 3 && integration.integrated == true)
        
        if (foundInvoiceSystemIntegration) {
            return foundInvoiceSystemIntegration;
        } else {
            return false;
        }
    },
    getOtaIntegrations: state => {
        return state.allIntegrations.filter(integration => integration.type == 2);
    },
    getIsTestingPrimaveraConnectionLoading: (state) => state.isTestingPrimaveraConnection,
    getIsResquestingPrimaveraSeriesLoading: (state) => state.isResquestingSeries,
    getPrimaveraSeries: (state) => state.primaveraSeries,
    getIsResquestingPaymentConditionsLoading: (state) => state.isResquestingPaymentConditions,
    getPaymentConditions: (state) => state.paymentConditions,
    getIsResquestingErpPaymentTypeLoading: (state) => state.isResquestingErpPaymentTypes,
    getErpPaymentTypes: (state) => state.erpPaymentTypes,
    getIsPrimaveraSettingsSaving: (state) => state.isPrimaveraSettingsSaving,
    getSelectedIntegration: (state) => state.selectedIntegration,
    getIsOctoConnecting: (state) => state.isOctoConnecting,
    getIsViatorConnecting: (state) => state.isViatorConnecting,
    getIsEnableOrDisableViatorConnecting: (state) => state.isEnableOrDisableViatorConnecting,
};

const actions = {
    enableOrDisableViatorIntegration: ({ state, rootState, dispatch }, payload) => {
        state.isEnableOrDisableViatorConnecting = true;
        
        return axios.patch(`/api/integration/viator/state?supplierId=${rootState.user.account.supplierId}&isActive=${payload}`).then(response => {
            state.isEnableOrDisableViatorConnecting = false;

            if (response.status === 204 || response.status === 200) {
                const message = payload
                    ? 'Viator integration activated!'
                    : 'Viator integration deactivated!';

                Vue.toasted[payload ? 'success' : 'info'](message);
                dispatch('downloadSupplierIntegrations');

                return true;
            }
        }).catch(err => {
            state.isEnableOrDisableViatorConnecting = false;
            Vue.toasted.error('Something went wrong, please contact support');
            
            throw err;
        })
    },

    createViatorIntegration: ({ state, rootState, dispatch }) => {
        state.isViatorConnecting = true;
        
        return axios.post(`/api/integration/viator/create?supplierId=${rootState.user.account.supplierId}`).then(response => {
            state.isViatorConnecting = false;

            if (response.status === 204 || response.status === 200) {
                dispatch('downloadSupplierIntegrations');
                Vue.toasted.success('New Viator integration created!');

                return response.data;
            }
        }).catch(err => {
            state.isViatorConnecting = false;
            Vue.toasted.error('Something went wrong, please contact support');
            
            throw err;
        })
    },

    createOctoIntegration: ({ state, rootState }, payload) => {
        state.isOctoConnecting = true;
        
        return axios.post('/api/integration/octoCreate', {
            name: payload.name,
            email: payload.email,
            supplierId: rootState.user.account.supplierId,
        }).then(response => {
            state.isOctoConnecting = false;

            if (response.status === 200) {
                Vue.toasted.success('New OCTO integration saved');

                return true;
            }
        }).catch(err => {
            state.isOctoConnecting = false;
            Vue.toasted.error(err.response.data);
            
            return false
        })
    },

    enableOctoIntegration: ({ state, rootState }, payload) => {
        state.isOctoConnecting = true;
        
        return axios.post('/api/integration/octoEnable', {
            name: payload.name,
            email: payload.email,
            supplierId: rootState.user.account.supplierId,
        }).then(response => {
            state.isOctoConnecting = false;

            if (response.status === 200) {
                Vue.toasted.success('OCTO integration enabled');

                return true;
            }
        }).catch(err => {
            state.isOctoConnecting = false;
            Vue.toasted.error('Something went wrong, please contact support');
            
            throw err;
        })
    },

    disableOctoIntegration: ({ state, rootState }, payload) => {
        state.isOctoConnecting = true;
        
        return axios.delete('/api/integration/octoDisable', {
            data: {
                name: payload.name,
                email: payload.email,
                supplierId: rootState.user.account.supplierId,
            }
        }).then(response => {
            state.isOctoConnecting = false;

            if (response.status === 200) {
                Vue.toasted.info('OCTO integration disabled');

                return true;
            }
        }).catch(err => {
            state.isOctoConnecting = false;
            Vue.toasted.error('Something went wrong, please contact support');
            
            throw err;
        })
    },

    savePrimaveraSettings: ({ state }, payload) => {
        state.isPrimaveraSettingsSaving = true;
        
        return axios.put('/api/erp/primaveraSettings', payload).then(response => {
            state.isPrimaveraSettingsSaving = false;

            if (response.status === 200) {
                Vue.toasted.success('Primavera settings is saved');

                return true;
            }
        }).catch(err => {
            state.isPrimaveraSettingsSaving = false;

            Vue.toasted.error('Something went wrong, please contact support');
            
            throw err;
        })
    },

    disablePrimavera: ({ state }) => {
        state.isDisablingPrimavera = true;
        
        return axios.put('/api/erp/disable', {ErpType: "PRIMAVERA"}).then(response => {
            state.isDisablingPrimavera = false;

            if (response.status === 200) {
                Vue.toasted.success('Primavera integration is disable');

                return true;
            }
        }).catch(err => {
            state.isDisablingPrimavera = false;

            Vue.toasted.error('Something went wrong, please contact support');
            
            throw err;
        })
    },

    requestErpPaymentTypes: ({ state, commit }) => {
        state.isResquestingErpPaymentTypes = true;
        
        return axios.get('/api/erp/erpPaymentTypes').then(response => {
            state.isResquestingErpPaymentTypes = false;

            if (response.status === 200) {
                commit('SET_ERP_PAYMENT_TYPES', response.data);

                return response.data;
            }
        }).catch(err => {
            state.isResquestingErpPaymentTypes = false;
            
            return err;
        })
    },

    requestPaymentConditions: ({ state, commit }) => {
        state.isResquestingPaymentConditions = true;
        
        return axios.get('/api/erp/paymentConditions').then(response => {
            state.isResquestingPaymentConditions = false;

            if (response.status === 200) {
                commit('SET_PAYMENT_CONDITIONS', response.data);

                return response.data;
            }
        }).catch(err => {
            state.isResquestingPaymentConditions = false;
            
            return err;
        })
    },

    requestSeries: ({ state, commit }) => {
        state.isResquestingSeries = true;
        
        return axios.get('/api/erp/series').then(response => {
            state.isResquestingSeries = false;

            if (response.status === 200) {
                commit('SET_SERIES', response.data);

                return response.data;
            }
        }).catch(err => {
            state.isResquestingSeries = false;
            
            return err;
        })
    },

    testPrimaveraConnection: ({ state }, payload) => {
        state.isTestingPrimaveraConnection = true;

        return axios.post('/api/erp/test', {
            defaultUrl: payload.defaultUrl,
            company: payload.company,
            username: payload.username,
            password: payload.password,
            defaultArticleListID: payload.defaultArticleListID,
            invoiceSystem: "primavera"
            
        }).then(response => {
            state.isTestingPrimaveraConnection = false;

            if (response.status === 200) {
                Vue.toasted.success('Validated');

                return true;
            }
        }).catch(err => {
            state.isTestingPrimaveraConnection = false;

            Vue.toasted.error('Invalid');
            
            return false;
        })
    },

    startIntegration: ({ dispatch }, integration) => {
        dispatch('openModalDirect', {
            name: 'startIntegration',
            component: integration.integratePopup
        })
    },

    openIntegrationSettings: ({ commit, dispatch, getters }, integration) => {
        integration.settings(commit, dispatch, getters);
    },

    downloadSupplierIntegrations: ({ rootState, state, dispatch }) => {
        state.isLoadingSupplierIntegrations = true;
        return axios.get('/api/supplier/GetSuppplierIntegrations', {
            params: {
                supplierId: rootState.user.account.supplierId
            }
        }).then(response => {
            state.isLoadingSupplierIntegrations = false;
            dispatch('prepareSupplilerIntegrations', response.data);
            
            return response.data;
        }).catch(e => {
            state.isLoadingSupplierIntegrations = false;

        })
    },

    prepareSupplilerIntegrations: ({ commit, state, rootGetters }, payload) => {
        const supplierIntegrations = payload;

        // Create integrations after create object with hardcode integrations
        //TODO: This hardcode integrations must come from BE - [allIntegrations] Escrever no jira a sugestão com as props e conteudo a ser devolvido
        const updatedIntegrations = state.allIntegrations.map(integration => {
            const matchedSupplierIntegration = supplierIntegrations.find(supplier => supplier.integration === integration.id);
            const showSetting = matchedSupplierIntegration && !!matchedSupplierIntegration.channelType ? (rootGetters.getAgentByChannelType(matchedSupplierIntegration.channelType) ? true : false) : false;
    
            return {
                ...integration,
                showSettings: showSetting,
                integrated: matchedSupplierIntegration ? true : false,
                integrationStatus: matchedSupplierIntegration ? matchedSupplierIntegration.integrationStatus : 4,
                integrationType: matchedSupplierIntegration ? matchedSupplierIntegration.integrationType : null,
                integrationStatusInfo: matchedSupplierIntegration ? matchedSupplierIntegration.integrationStatusInfo : null,
                integrationStatusInfoMessage: matchedSupplierIntegration ? matchedSupplierIntegration.integrationStatusInfoMessage : null,
                apiKey: matchedSupplierIntegration ? matchedSupplierIntegration.apiKey : null,
                baseUrl: matchedSupplierIntegration ? matchedSupplierIntegration.baseUrl : null,
                name: matchedSupplierIntegration ? matchedSupplierIntegration.name : null,
                email: matchedSupplierIntegration ? matchedSupplierIntegration.email : null,
                integration: matchedSupplierIntegration ? matchedSupplierIntegration.integration : null,
                channelId: matchedSupplierIntegration ? matchedSupplierIntegration.channelId : null,
                channelType: matchedSupplierIntegration ? matchedSupplierIntegration.channelType : null,
            };
        });

        // Filter integrations of type OCTO (ID 210)
        const filteredOctoIntegrations = supplierIntegrations.filter(supplier => supplier.integration === 210);
    
        // Create new formatted OCTO integrations
        const octoStructuredIntegrations = filteredOctoIntegrations.map((octo, idx) => ({
            id: idx,
            apiKey: octo.apiKey,
            baseUrl: octo.baseUrl,
            integration: octo.integration,
            channelId: octo.channelId,
            channelType: octo.channelType,
            type: 2,
            label: octo.name,
            integrated: true,
            comingSoon: false,
            integrationStatus: octo.integrationStatus,
            integrationType: octo.integrationType,
            integrationStatusInfo: octo.integrationStatusInfo,
            integrationStatusInfoMessage: octo.integrationStatusInfoMessage,
            showSettings: !!octo.channelType && !!octo.channelId ? (rootGetters.getOctoAgent({channelType: octo.channelType, channelId: octo.channelId}) ? true : false) : false,
            color: { main: '#adadad' },
            logo: {
                color: require('@/assets/images/integrations/octo/octo.png'),
                white: require('@/assets/images/integrations/octo/octo.png'),
            },
            settings: (commit, dispatch, getters) => {
                dispatch('setSelectedPerson', getters.getOctoAgent({channelType: octo.channelType, channelId: octo.channelId}));
                dispatch('openModal', 'AgentView');
            },
            name: octo.name,
            email: octo.email
        }));
    
        // Add all the integrations
        const allIntegrations = [...updatedIntegrations, ...octoStructuredIntegrations];
    
        // Group integrations by type - Invoicing | Payment Gateway | OTAs
        const groupedIntegrations = state.integrationTypes.map(type => ({
            ...type,
            integrations: allIntegrations.filter(integration => integration.type === type.id)
        }));

        commit('SET_SUPPLIER_INTEGRATIONS', {
            allIntegrations,
            groupedIntegrations
        });
    },

    downloadInvoicingIntegrationDetails: ({ rootState }, payload) => {
        return axios.get('/api/supplier/GetInvoicingIntegrationDetails', {
            params: {
                supplierId: rootState.user.account.supplierId,
                integration: payload
            }
        }).then(response => {
            return response;
        }).catch(err => {
            return err;
        })
    },

    downloadPaymentIntegrationDetails: ({ rootState }, payload) => {
        return axios.get('/api/supplier/GetPaymentIntegrationDetails', {
            params: {
                supplierId: rootState.user.account.supplierId,
                integration: payload
            }
        }).then(response => {
            return response;
        }).catch(err => {
            return err;
        })
    },

    requestDeactivateGYG: ({ rootState, dispatch }) => {
        return axios.get('/api/supplier/DisableGYGOnSupplier', {
            params: {
                supplierId: rootState.user.account.supplierId,
            }
        }).then(response => {
            dispatch('downloadSupplierIntegrations');
            
            return response;
        }).catch(err => {
            return err;
        })
    },

    requestIntegrationActivationViaEmail: ({ rootState, dispatch }, integration) => {
        return axios.post('/api/supplier/RequestIntegrationActivation', {
            isToActivate: true,
            supplierId: rootState.user.account.supplierId,
            integration: integration.id,
        }).then(response => {
            dispatch('downloadSupplierIntegrations');

            return response;
        }).catch(err => {
            return err;
        })
    },

    requestIntegrationDeactivationViaEmail: ({ rootState, dispatch }, integration) => {
        return axios.post('/api/supplier/RequestIntegrationActivation', {
            isToActivate: false,
            supplierId: rootState.user.account.supplierId,
            integration: integration.id,
        }).then(response => {
            dispatch('downloadSupplierIntegrations');
            
            return response;
        }).catch(err => {
            return err;
        })
    },

    saveStripeIntegration: ({ rootState }, payload) => {
        return axios.post('/api/supplier/SetStripeKeys', {
            supplierId: rootState.user.account.supplierId,
            secretKey: payload.secretKey,
            publicKey: payload.publicKey,
        }).then(response => {
            return response;
        }).catch(err => {
            return err;
        })
    },

    setIntegration: ({ commit }, payload) => {
        commit('SET_INTEGRATION', payload);
    },

    resetIntegration: ({ commit }) => {
        commit('RESET_INTEGRATION');
    }
};

const mutations = {
    SET_SUPPLIER_INTEGRATIONS: (state, payload) => {
        state.finalIntegrations = payload.allIntegrations;
        state.groupedIntegrations = payload.groupedIntegrations;
    },

    SET_SERIES: (state, payload) => {
        state.primaveraSeries = payload;
    },

    SET_PAYMENT_CONDITIONS: (state, payload) => {
        state.paymentConditions = payload;
    },

    SET_PAYMENT_TYPES: (state, payload) => {
        state.paymentTypes = payload;
    },

    SET_ERP_PAYMENT_TYPES: (state, payload) => {
        state.erpPaymentTypes = payload;
    },

    SET_INTEGRATION: (state, payload) => {
        state.selectedIntegration = payload;
    },

    RESET_INTEGRATION: (state) => {
        state.selectedIntegration = null;
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/integrations.js